import React from 'react';
import { Link } from 'react-router-dom';
import { useWishlistStore, useCartStore } from '../store';
import { toast } from 'react-toastify';
import './Wishlist.css';

export default function Wishlist() {
  const { items, toggle } = useWishlistStore();
  const { addItem } = useCartStore();

  if (items.length === 0) return (
    <div className="wishlist-empty">
      <div className="cart-empty__icon">❤️</div>
      <h2>Your wishlist is empty</h2>
      <p>Save research compounds you're interested in for easy access later.</p>
      <Link to="/shop" className="btn btn-primary btn-lg">Browse Products</Link>
    </div>
  );

  return (
    <div className="container" style={{ padding: '2.5rem 0' }}>
      <h1 style={{ fontSize: '1.75rem', fontWeight: 800, marginBottom: '2rem' }}>My Wishlist <span style={{ color: 'var(--gray-400)', fontWeight: 400, fontSize: '1rem' }}>({items.length} items)</span></h1>
      <div className="grid-4">
        {items.map(p => (
          <div key={p.id} className="wish-card card">
            <Link to={`/shop/${p.slug}`}>
              <img src={p.images?.[0] || 'https://placehold.co/300x200?text=Peptide'} alt={p.name} style={{ width: '100%', height: 160, objectFit: 'cover' }} />
            </Link>
            <div style={{ padding: '1.125rem' }}>
              <p style={{ fontSize: '0.75rem', color: 'var(--green-600)', fontWeight: 600, textTransform: 'uppercase', marginBottom: '0.375rem' }}>{p.category}</p>
              <Link to={`/shop/${p.slug}`} style={{ textDecoration: 'none', color: 'var(--gray-900)', fontWeight: 600, fontSize: '0.9375rem', display: 'block', marginBottom: '0.5rem' }}>{p.name}</Link>
              <p style={{ fontWeight: 700, color: 'var(--green-600)', fontSize: '1.125rem', marginBottom: '1rem' }}>${(p.salePrice || p.price).toFixed(2)}</p>
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <button className="btn btn-primary btn-sm" style={{ flex: 1 }} onClick={() => { addItem(p, 1); toast.success('Added to cart!'); }}>🛒 Add to Cart</button>
                <button className="btn btn-secondary btn-sm" onClick={() => { toggle(p); toast.info('Removed from wishlist'); }}>🗑️</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
